export default __webpack_public_path__ + "static/media/components_park_green.095661e3.png";